<template>
  <div class="mt-5">
    <h4>ราคาคอร์สและระยะเวลาเรียน</h4>
    <div class="price-and-duration-section">
      <!-- onsite course -->
      <div class="management-section">
        <div class="title-section">
          <div class="title-text">
            <b-form-checkbox
              v-model="isOnsite"
              name="check-button"
              switch
              size="lg"
              @change="updateCourseType"
            ></b-form-checkbox>
            <span>รูปแบบคอร์สเรียนรอบสอนสด</span>
            <span class="onsite-badge">รอบสด</span>
          </div>
          <b-button variant="primary" @click="showModal('ONSITE')">
            จัดการ
          </b-button>
        </div>
        <div class="duration-section">
          <b-row>
            <b-col cols="4"><p>ระยะเวลาเรียน :</p></b-col>
            <b-col cols="8">
              <p v-if="courseOnsiteInfo.startLearningDate">
                {{ courseOnsiteInfo.startLearningDate | thaiDateFilter }}
                -
                {{ courseOnsiteInfo.finishLearningDate | thaiDateFilter }}
              </p>
              <p v-else>-</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4"><p>ราคาคอร์ส :</p></b-col>
            <b-col cols="8">
              <p v-if="courseOnsiteInfo.price > 0">
                {{ courseOnsiteInfo.price | formatNumber }}
                <span v-if="courseOnsiteInfo.promotionPrice">
                  (ลดเหลือ
                  {{ courseOnsiteInfo.promotionPrice | formatNumber }} บาท)
                </span>
              </p>
              <p v-else>ฟรี</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4"><p>เวลาเรียน :</p></b-col>
            <b-col cols="8">
              <p v-if="courseOnsiteInfo.classStartTime">
                {{ courseOnsiteInfo.classStartTime }}
                -
                {{ courseOnsiteInfo.classFinishTime }}
              </p>
              <p v-else>-</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4"><p>วันเรียนในสัปดาห์ :</p></b-col>
            <b-col cols="8">
              <p>
                {{ formattedClassDays }}
              </p>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- online course -->
      <div class="management-section">
        <div class="title-section">
          <div class="title-text">
            <b-form-checkbox
              v-model="isOnline"
              name="check-button"
              switch
              size="lg"
              @change="updateCourseType"
            ></b-form-checkbox>
            <span>รูปแบบคอร์สเรียนออนไลน์</span>
            <span class="online-badge">{{ onlineText }}</span>
          </div>
          <b-button variant="primary" @click="showModal('ONLINE')">
            จัดการ
          </b-button>
        </div>
        <div class="duration-section">
          <b-row>
            <b-col cols="4"><p>ระยะเวลาเรียน :</p></b-col>
            <b-col cols="8">
              <p v-if="courseInfo.startLearningDate">
                {{ courseInfo.startLearningDate | thaiDateFilter }} -
                {{ courseInfo.finishLearningDate | thaiDateFilter }}
              </p>
              <p v-else>-</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4"><p>ราคาคอร์ส :</p></b-col>
            <b-col cols="8">
              <p v-if="courseInfo.price > 0">
                {{ courseInfo.price | formatNumber }}
                <span v-if="courseInfo.promotionPrice">
                  (ลดเหลือ
                  {{ courseInfo.promotionPrice | formatNumber }} บาท)
                </span>
              </p>
              <p v-else>ฟรี</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4"><p>เวลาเรียน :</p></b-col>
            <b-col cols="8">
              <p>{{ learnDuration }}</p>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <b-modal
      id="onsite-course-price-modal"
      v-model="showOnsiteCoursePriceModal"
      title="ราคาคอร์สและระยะเวลาเรียนรอบสด"
      size="lg"
      centered
      hide-footer
    >
      <OnsitePricingForm @toggle-modal="showModal('ONSITE')" />
    </b-modal>
    <b-modal
      id="online-course-price-modal"
      v-model="showOnlineCoursePriceModal"
      title="ราคาคอร์สและระยะเวลาเรียนออนไลน์"
      size="lg"
      centered
      hide-footer
    >
      <OnlineCoursePricingForm @toggle-modal="showModal('ONLINE')" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Numeral from "numeral";
import OnsitePricingForm from "./OnsitePricingForm.vue";
import OnlineCoursePricingForm from "./OnlineCoursePricingForm.vue";
import date from "../../analytics/shared/mixins/date";

export default {
  mixins: [date],
  components: { OnsitePricingForm, OnlineCoursePricingForm },
  filters: {
    formatNumber: function(value) {
      return Numeral(value).format("0,00");
    },
  },
  computed: {
    ...mapGetters("CourseManagement", ["courseInfo", "courseOnsiteInfo"]),
    onlineText() {
      if (this.comId == 1000001) {
        return "Aurum Online";
      } else if (this.comId == 1000002) {
        return "AP Anytime";
      } else if (this.comId == 1000003) {
        return "Bio Beam Home Visit";
      }
      return "";
    },
    formattedClassDays() {
      const days = this.courseOnsiteInfo?.classDays;

      if (!days || !Array.isArray(days) || days.length === 0) {
        return "-";
      }

      const dayMap = {
        Sunday: "อาทิตย์",
        Monday: "จันทร์",
        Tuesday: "อังคาร",
        Wednesday: "พุธ",
        Thursday: "พฤหัสบดี",
        Friday: "ศุกร์",
        Saturday: "เสาร์",
      };

      return days.map((day) => dayMap[day] || day).join(", ");
    },
    learnDuration() {
      let text = "";
      if (!this.courseInfo.learnDuration && !this.courseInfo.learnTimeLimit) {
        return "ไม่จำกัดวันเรียน ไม่จำกัดชั่วโมงเรียน";
      }

      if (this.courseInfo.learnDuration) {
        text = Numeral(this.courseInfo.learnDuration).format("0,00") + " วัน ";
      } else {
        text = "ไม่จำกัดวันเรียน ";
      }
      if (this.courseInfo.learnTimeLimit) {
        text +=
          "(ไม่เกิน " +
          Numeral(this.courseInfo.learnTimeLimit).format("0,00") +
          " ชั่วโมง)";
      } else {
        text += "(ไม่จำกัดชั่วโมงเรียน)";
      }
      return text;
    },
  },
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      courseId: this.$route.params.courseId,
      showOnsiteCoursePriceModal: false,
      showOnlineCoursePriceModal: false,
      isOnsite: null,
      isOnline: null,
    };
  },
  methods: {
    ...mapActions("CourseManagement", [
      "getCourseInfo",
      "getCourseOnsiteInfo",
      "updateCourseInfo",
    ]),
    async updateCourseType() {
      let params = {
        courseOnlineType: "",
      };
      if (this.isOnline && this.isOnsite) {
        params.courseOnlineType = "FLEX";
      } else if (this.isOnline) {
        params.courseOnlineType = "ONLINE";
      } else if (this.isOnsite) {
        params.courseOnlineType = "ONSITE";
      }

      await this.updateCourseInfo({
        courseId: this.courseId,
        attribute: params,
      }).then(() => {
        this.getCourseInfo({
          courseId: this.courseId,
          temp: true,
          excepts: "numberOfStudent,numberOfActiveStudent",
        });
      });
    },
    showModal(type) {
      if (type === "ONLINE") {
        this.showOnlineCoursePriceModal = !this.showOnlineCoursePriceModal;
        this.getCourseInfo({
          courseId: this.courseId,
          temp: true,
          excepts: "numberOfStudent,numberOfActiveStudent",
        });
      } else if (type === "ONSITE") {
        this.showOnsiteCoursePriceModal = !this.showOnsiteCoursePriceModal;
        this.getCourseOnsiteInfo(this.courseId);
        this.getCourseInfo({
          courseId: this.courseId,
          temp: true,
          excepts: "numberOfStudent,numberOfActiveStudent",
        });
      }
    },
  },
  watch: {
    courseInfo(newValue) {
      if (newValue.courseOnlineType === "FLEX") {
        this.isOnline = true;
        this.isOnsite = true;
      } else if (newValue.courseOnlineType === "ONLINE") {
        this.isOnline = true;
      } else if (newValue.courseOnlineType === "ONSITE") {
        this.isOnsite = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.price-and-duration-section {
  display: flex;
  flex-direction: column;
  gap: 40px;

  .management-section {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .title-section {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-text {
        display: flex;
        align-items: center;

        span {
          margin-bottom: 0;
        }

        .onsite-badge,
        .online-badge {
          color: #fff;
          padding: 2px 8px;
          border-radius: 2px;
          font-size: 12px;
          margin-left: 10px;
        }

        .onsite-badge {
          background-color: #17a2b8;
        }

        .online-badge {
          background-color: #f99f4d;
        }
      }
    }

    .duration-section {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border: 1px solid #cdcdcd;
      padding: 20px 30px;
    }
  }
}
</style>
